import { StandardAccountModel } from '~/app/views/StandardAccounts';
import useQuery, { QueryOptions, QueryResult } from '../useQuery';

/**
 * Custom hook responsible to fetch accounts
 */
export function useStandardAccounts({ options }: { options?: QueryOptions }): QueryResult<StandardAccountModel[]> {
    const accountsQuery = useQuery<StandardAccountModel[]>('/standard-account', [], {
        ...options,
        useCache: options?.useCache ?? true,
    });
    return {
        ...accountsQuery,
        data: accountsQuery.data,
    };
}
